import { EXPRESS_API } from 'configs/api/expressApi';
import { useQuery } from 'react-query';
import { highlightKeys } from './highlightKeys';
import { useToastError } from 'lib/hooks';
import { HIGHLIGHTS_SORT_KEYS } from 'app/pages/ai-configuration/personalization/highlights/constants';
import { PaginationConstants } from 'lib/const/PaginationConstants';
import { useTranslation } from 'react-i18next';

export interface IHighlight {
  highlightId: number;
  title: string;
  description: string;
}

export interface IHighlightResponse {
  highlights: IHighlight[];
  count: number;
}

export interface IHighlightSortingParams {
  sortKey: HIGHLIGHTS_SORT_KEYS | null;
  order: PaginationConstants.ASCENDING | PaginationConstants.DESCENDING;
  start: number;
  limit: number;
}

const getHighlights = async (
  params: IHighlightSortingParams
): Promise<IHighlightResponse> => {
  const response = await EXPRESS_API.get('/highlights', {
    params,
  });
  return response.data;
};

export const useQueryHighlights = (params: IHighlightSortingParams) => {
  const { t } = useTranslation();
  const { showError } = useToastError();

  return useQuery(highlightKeys.list(params), () => getHighlights(params), {
    onError: error =>
      showError(error || t(`An error occurred while fetching highlights.`)),
  });
};
